export const hi = {
    'nav.today': "आज का अवलोकन",
    'nav.calendar': "मांग कैलेंडर",
    'nav.rates': "दरें और नियम",
    'nav.automation': "स्वचालन केंद्र",
    'nav.audit': "ऑडिट लॉग",
    'nav.settings': "सेटिंग्स",
    'sidebar.status': "कनेक्टेड",
    'stat.occupancy': "व्यापृति (Occupancy)",
    'stat.adr': "औसत दैनिक दर (ADR)",
    'stat.revpar': "RevPAR",
    'stat.revenue': "अनुमानित राजस्व",
    'stat.trend.vsLastWeek': "बनाम पिछला सप्ताह",
    'stat.trend.onPace': "गति पर",
    'dashboard.actions.title': "अनुशंसित कार्रवाई",
    'dashboard.actions.empty': "कोई कार्रवाई नहीं मिली।",
    'filter.all': "सभी",
    'filter.pricing': "मूल्य निर्धारण",
    'filter.restriction': "प्रतिबंध",
    'action.approve': "स्वीकृत करें",
    'action.reject': "अस्वीकार करें",
    'action.risk.low': "कम जोखिम",
    'action.risk.medium': "मध्यम जोखिम",
    'action.risk.high': "उच्च जोखिम",
    'action.label.current': "वर्तमान",
    'action.label.proposed': "प्रस्तावित",
    'action.metric.impact': "प्रभाव",
    'action.metric.why': "क्यों",
    'action.status.executed': "स्वचालित निष्पादित",
    'header.search': "खोजें...",
    'header.logout': "लॉग आउट",
    'auto.level.title': "ऑटोपायलट स्तर",
    'auto.level.manual': "मैनुअल",
    'auto.level.manual.desc': "आप हर सिफारिश को स्वीकृत करते हैं।",
    'auto.level.assisted': "सहायक",
    'auto.level.assisted.desc': "कम जोखिम को ऑटो-स्वीकृत करें। बड़े बदलावों की समीक्षा करें।",
    'auto.level.auto': "पूर्ण स्वचालित",
    'auto.level.auto.desc': "AI आपकी सीमाओं के भीतर 24/7 कीमतों का प्रबंधन करता है।",
    'auto.level.active': "सक्रिय",
    'auto.guardrails.title': "सुरक्षा सीमाएं",
    'auto.guardrails.maxIncrease': "अधिकतम दैनिक वृद्धि",
    'auto.guardrails.maxIncrease.desc': "कीमत के झटकों को रोकें।",
    'auto.guardrails.maxDecrease': "अधिकतम दैनिक कमी",
    'auto.guardrails.maxDecrease.desc': "कीमतों को बहुत कम होने से रोकें।",
    'auto.guardrails.minRate': "न्यूनतम दर",
    'auto.guardrails.minRate.desc': "इस कीमत से नीचे कभी न बेचें (नेट)।",
    'auto.emergency.title': "आपातकालीन नियंत्रण",
    'auto.emergency.label': "आपातकालीन रोक",
    'auto.emergency.desc': "सभी स्वचालन को तुरंत रोकें।",
    'auto.emergency.btn': "सिस्टम रोकें",
    'rates.filter.all': "सभी कमरे के प्रकार",
    'rates.filter.next14': "अगले 14 दिन",
    'rates.export': "निर्यात",
    'audit.table.time': "समय",
    'audit.table.actor': "कर्ता",
    'audit.table.category': "श्रेणी",
    'audit.table.action': "कार्रवाई",
    'audit.table.details': "विवरण",
    'audit.table.status': "स्थिति",
    'settings.pms.title': "PMS कनेक्शन",
    'settings.pms.connected': "से जुड़ा हुआ",
    'settings.pms.disconnect': "डिस्कनेक्ट करें",
    'settings.account.title': "खाता",
    'settings.account.role': "भूमिका",
    'settings.restart': "ऑनबोर्डिंग पुनः आरंभ करें",
    'onboard.title': "PMS कनेक्ट करें",
    'onboard.desc': "इन्वेंट्री सिंक करने के लिए अपना प्रॉपर्टी मैनेजमेंट सिस्टम चुनें।",
    'onboard.connecting': "कनेक्ट हो रहा है...",
    'onboard.connect': "कनेक्ट करें",
    'onboard.success.title': "सेटअप पूर्ण!",
    'onboard.success.desc': "**SynthHotel Berlin** अब सिंक हो गया है।",
    'onboard.success.sub': "3 कमरे के प्रकार, 14 दर योजनाएं और 243 बुकिंग आयात की गईं।",
    'onboard.btn.dashboard': "डैशबोर्ड पर जाएं",
    'action.dynamic.weekend.title': "वीकेंड की दर बढ़ाएं",
    'action.dynamic.weekend.desc': "शनिवार को व्यापृति > 75%, मांग मजबूत (24 घंटे में +12 कमरे)।",
    'action.dynamic.minstay.title': "2-रात न्यूनतम ठहराव सक्षम करें",
    'action.dynamic.minstay.desc': "टेलर स्विफ्ट कॉन्सर्ट की घोषणा। 1-रात के ठहराव को रोकें।",
    'action.dynamic.distress.title': "दर कम करें (कम मांग)",
    'action.dynamic.distress.desc': "अगले मंगलवार को व्यापृति 35%। प्रतिस्पर्धियों ने €10 कम किया।",
    'action.dynamic.gap.title': "गैप भरें: CTA हटाएं",
    'action.dynamic.gap.desc': "एक रात का गैप मिला। बेचने के लिए 'Close To Arrival' हटाएं।",
};
